import axios from "axios";
import { API_URL } from "@/constants/environment";

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

// Initialize the interceptors only once
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token") || localStorage.getItem("onboard_access_token");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log("401 Unauthorized - redirecting to home page");
      localStorage.removeItem("access_token");
      localStorage.removeItem("onboard_access_token");
      // Redirect to main home page on 401
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
